import { useState, useEffect, ReactNode } from 'react';

import parse from 'html-react-parser';
import { marked } from 'marked';

import { APIBaseChronos } from '@/api/hosts';
import { useGetReleaseNotes } from '@/api/queries/useGetReleaseNotes';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';

export const ReleaseNotes = () => {
  const { data: releaseNotes, isLoading } = useGetReleaseNotes();
  const [parsedNotes, setParsedNotes] = useState<ReactNode>(null);

  useEffect(() => {
    const parseNotes = async () => {
      if (releaseNotes) {
        try {
          const renderer = new marked.Renderer();

          // Use crossorigin="anonymous" to stop CORS errors
          renderer.image = ({ href, title, text }) => {
            return `<img crossorigin="anonymous" src="${APIBaseChronos}/api/static/${href}" alt="${text}" title="${title || ''}" class="my-12! w-3/4 mx-auto rounded-lg shadow-lg/2" />`;
          };

          const parsed: string = await marked.parse(releaseNotes, { renderer });
          setParsedNotes(parse(parsed));
        } catch (err) {
          console.error('Error parsing release notes:', err);
        }
      }
    };

    parseNotes();
  }, [releaseNotes]);

  return (
    <>
      <Breadcrumb items={[{ href: '/release-notes', label: 'Release Notes', active: true }]} />
      <PageContainer>
        <div className="mx-auto mb-16 w-full max-w-2xl">
          <div className="my-24">
            <h1 className="font-serif text-4xl font-medium">Release Notes</h1>
            <p className="my-3 text-sm text-gray-600">
              Stay updated with the latest features and improvements in Wexler.
            </p>
          </div>

          <div className="prose prose-sm prose-h1:font-medium prose-li:leading-normal prose-p:leading-normal prose-h3:mt-4 prose-h3:font-medium prose-h1:mb-10 prose-hr:my-14 prose-code:before:content-none prose-code:after:content-none max-w-full">
            {isLoading ? (
              <div className="flex items-center justify-center py-8">
                <div className="text-gray-500">Loading release notes...</div>
              </div>
            ) : (
              parsedNotes
            )}
          </div>
        </div>
      </PageContainer>
    </>
  );
};
